var React = require('react');

function UserIconGreyInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#606060","fillRule":"evenodd"},[React.createElement("path",{"d":"M10.151 3.572a3.573 3.573 0 11-7.145 0 3.573 3.573 0 017.145 0","key":0}),React.createElement("path",{"d":"M9.227 7.335a4.57 4.57 0 01-2.648.842c-.985 0-1.9-.312-2.649-.842-3.768.76-3.86 3.657-3.86 6.513 0 .3.107.411.249.515C1.929 15.549 4.649 16 6.576 16c1.929 0 4.65-.45 6.26-1.637.142-.105.25-.216.25-.515-.001-2.855-.091-5.751-3.859-6.513z","key":1})]));
}

UserIconGreyInline.defaultProps = {"width":"14","height":"16"};

module.exports = UserIconGreyInline;

UserIconGreyInline.default = UserIconGreyInline;
